/* eslint-disable */

import React from "react";
import { makePost } from "@culturehq/client";
import { Form, Modal, SelectField, SubmitButton, Success, TextField } from "@culturehq/components";

import { useTryCatch } from "app/hooks";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import PageHeader from "components/display/PageHeader";
import ChqModal from "./common/ChqModal";

// Why am I explicitly violating the type system you ask? Because our select
// component isn't generic even though it needs to be. This is definitely
// something we should fix in the future. At the moment, it only accepts string
// values in the type system, but in reality it should be something like
// SelectField<boolean>.
const anonymousOptions = [
  { label: t("No - Include my name with the feedback"), value: false },
  { label: t("Yes - This message should be anonymous"), value: true }
];

const FeedbackForm = ({ error, onSubmit }) => (
  <Form onSubmit={onSubmit} initialValues={{ anonymous: false }}>
    {error && <ErrorMessage error={error} />}
    <TextField name="body" required>
      <Trans>Message</Trans>
    </TextField>
    <SelectField name="anonymous" options={anonymousOptions}>
      <Trans>Submit Anonymously?</Trans>
    </SelectField>
    <SubmitButton fillParent primary>
      {submitting => (submitting ? t("Submitting...") : t("Submit Feedback"))}
    </SubmitButton>
  </Form>
);

const Feedback = ({ children, onClose }) => {
  const [{ error, success }, onSubmit] = useTryCatch(
    ({ body, anonymous }) => makePost("/feedbacks", { body, anonymous })
  );

  return (
    <ChqModal trigger={children} width="narrow" onClose={onClose}>
      <Modal.Heading>
        <Trans>Submit Feedback</Trans>
      </Modal.Heading>
      <Modal.Body>
        <PageHeader title={t("Submit Feedback")}>
          <Trans>
            Use the button below to send feedback directly to your
            organization&#39;s admins. Your feedback may be a compliment,
            suggestion, or critique, and can be marked anonymous.
          </Trans>
        </PageHeader>
        {
          success
            ? <Success>Feedback submitted</Success>
            : <FeedbackForm error={error} onSubmit={onSubmit} />
        }
      </Modal.Body>
    </ChqModal>
  );
};

export default Feedback;
